module.exports = __webpack_public_path__ + "img/slider-image-01.54c06786.png";